exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vue-editor-control.disabled[data-v-0bdf223d]{background-color:#ddd;opacity:.8}.vue-editor-control.disabled .ql-toolbar[data-v-0bdf223d],.vue-editor-control.readonly .ql-toolbar[data-v-0bdf223d]{display:none}.disabled-mode[data-v-0bdf223d],.readonly-mode[data-v-0bdf223d]{padding:20px;color:#999;font-size:.8rem}", ""]);

